import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import i18n from '../../../src/i18n/translate';

export default class FileUploadLabel extends React.Component {
  static propTypes = {
    text: PropTypes.string,
    removeItem: PropTypes.func,
    closable: PropTypes.bool
  };

  static defaultProps = {
    closable: false,
    container: {
      className: ''
    }
  };

  render() {
    return (
      <div className="file-upload-label-container">
        {this.props.text || i18n.t('No File')} {this.props.closable && <Icon iconType="close" onClick={e => this.props.removeItem(e, this.props.text)} />}
      </div>
    );
  }
}
